"use client";

import {
  OTPContext,
  OTPContextProvider,
  OTPContextWrapper,
} from "@/components/sections/CommonModals/context";
import styles from "./CityListingBannerForm.module.scss"
import { useCallback, useRef, useState } from "react";
import HomeConnectModalFormNew from "@/revamp/sections/HomeNewFaq/HomeConnectModalFormNew";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import CityConnectModalForm from "../CityConnectModalForm";

type LeadFormWrapperNewProps = {
  associatedPrograms?: any[];
  isLambdaAPI?: boolean;
  isSpecificPage?: boolean;
  isFaq?: boolean;
  isProgram?: boolean;
  RFIHeading?: string;
  seatsFilledUI?: number;
  isSeatsFilledUI?: boolean;
  isProgramListPage?: boolean;
  isMobile?: boolean;
  landingPageValue?: string;
  isBanner?:boolean
};

const CityListingBannerForm = ({
  associatedPrograms = [],
  isLambdaAPI = false,
  isSpecificPage = false,
  isFaq = false,
  isProgram = false,
  RFIHeading,
  seatsFilledUI,
  isSeatsFilledUI = false,
  isProgramListPage = false,
  isMobile = false,
  landingPageValue = "",
  isBanner=false
}: LeadFormWrapperNewProps) => {
  const [message, setMessage] = useState(false);
  const [isOtpValidated, setIsOtpValidated] = useState(false);
  const [leadFailed, setLeadFailed] = useState(false);
  const [formResponse, setFormResponse] = useState(null);

  const [
    isApplicationRedirectLoaderDisabled,
    setApplicationRedirectLoaderDisabled,
  ] = useState(true);

  const [apiResponseURL, setAPIResposeURL] = useState<string | null>(null);

  const clickedInsideLeadForm = useRef(false);

  const handleClickInsideLeadForm = () => {
    if (!clickedInsideLeadForm.current) {
      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Get Free Counselling",
        section_name: "Footer",
        header_title: "NA",
        page_type: "Home Page",
        page_url: window.location.href || "NA",
      });

      updateStateSession({
        parentSection: "Footer",
        leadStartingCta: "Get Free Counselling",
      });

      window.webengage.track("Open RFI Clicked", {
        "Page Type": getGlobalStateValue("pageType"),
        "Section Name": "Footer",
      });

      clickedInsideLeadForm.current = true;
    }
  };

  const handleOtpValidation = useCallback((status: boolean) => {
    setIsOtpValidated(status);
  }, []);

  const handleLeadCheck = useCallback((status: boolean) => {
    setLeadFailed(status);
  }, []);

  return (
    <div
      className={`${styles.root} ${!isBanner && "border"} `}
      onClick={handleClickInsideLeadForm}
    >
      {!isApplicationRedirectLoaderDisabled ? (
        <div>
          <div className={styles.thankYou}>Thank You For Your Interest!</div>

          <div className={styles.paragraph}>
            We have successfully received your information. One of our
            counsellors will contact you shortly.
          </div>

          <a href={apiResponseURL || "#"} className={styles.proceedToApply}>
            Proceed to Apply
          </a>
        </div>
      ) : (
        <>
            <div className={styles.heading}>
             {RFIHeading}
            </div>

          <div className={styles.formSection}>
            <OTPContextProvider isLambdaAPI={false}>
              <OTPContext.Consumer>
                {() => (
                  <OTPContextWrapper isNewProgramTemp={true}>
                    <CityConnectModalForm
                      isSpecificPage={isSpecificPage}
                      associatedPrograms={associatedPrograms}
                      setMessage={setMessage}
                      setFormResponse={setFormResponse}
                      isOtpValidated={handleOtpValidation}
                      checkLeadFail={handleLeadCheck}
                      setApplicationRedirectLoaderDisabled={
                        setApplicationRedirectLoaderDisabled
                      }
                      setAPIResposeURL={setAPIResposeURL}
                      seatsFilled={seatsFilledUI}
                      isSeatsFilled={isSeatsFilledUI}
                      isProgramListPage={isProgramListPage}
                      isMobile={isMobile}
                      landingPageValue={landingPageValue}
                      isBanner={isBanner}
                    />
                  </OTPContextWrapper>
                )}
              </OTPContext.Consumer>
            </OTPContextProvider>
          </div>
        </>
      )}
    </div>
  );
};

export default CityListingBannerForm;
